// Constants.
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  errorStatus: '',
  errorMessage: '',
};

export default function reports(state = initialState, action = {}) {
  switch (action.type) {
    case ErrorConstants.LOAD_REQUEST_FAILURE: {
      let message = '';
      if (action.response && action.response.data && action.response.data.error) {
        message = action.response.data.error;
      }
      else if (action.response && action.response.data && action.response.data.detail) {
        message = action.response.data.detail;
      }
      else if (action.response && action.response.statusText) {
        message = action.response.data.detail;
      }
      return {
        ...state,
        errorStatus: action.response && action.response.status,
        errorMessage: message,
      };
    }
    default:
      return state;
  }
}
